// @flow

import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'

type Props = {
  children: any,
  padding: number,
  width: number,
}

class WhitePublicScreen extends React.Component<Props> {
  static defaultProps = {
    padding: 34,
    width: 778,
  }

  render() {
    const { children, padding, width } = this.props

    return (
      <>
        <Container padding={padding} width={width}>
          {children}
        </Container>
        <GlobalStyle />
      </>
    )
  }
}

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #f8f8f8;
  }
`

const Container = styled.div`
  margin: 0 auto 0;
  width: ${props => props.width}px;
  padding: ${props => props.padding}px;
  background-color: #ffffff;
`

const Content = styled.div`
  margin-top: 50px;
`

export default WhitePublicScreen
